import axios from './axios';
import config from '../../helpers/config';

export default (designId, newName) => (
  axios.post(
    `${config.designBuilderLoadDesignPath}/${designId}/copy`,
    { Name: newName },
  )
);
